import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { telegramChatsDic } from 'app/store/project/notices/notices.selectors';
import { getContactLabel, NoticeRecipient } from 'core/http/project/notice/notice.interfaces';
import { NoticeLogOutput, NoticesLogService } from 'core/http/project/notices-log/notices-log.service';
import { Observable } from 'rxjs';
import { PaginatedData } from 'shared/common/types';
import { Criteria } from 'shared/criteria/Criteria';

@Component({
  selector: 'app-notices-log',
  templateUrl: './notices-log.component.html',
  styleUrls: ['./notices-log.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoticesLogComponent {
  readonly NOTICES_KEY = 'notices';
  readonly chats = this.store$.select(telegramChatsDic);

  constructor(
    private noticesLogService: NoticesLogService,
    private store$: Store,
    private translateService: TranslateService,
  ) { }

  dataSource: PaginatedData<NoticeLogOutput> = (c: Criteria) => {
    const criteria = c.clone({ ordering: { field: 'createdAt', ascending: 'desc' } });

    return this.noticesLogService.getNotices(criteria);
  };

  getContactLabel(recipient: NoticeRecipient): Observable<string> {
    return getContactLabel(recipient, this.chats, this.translateService);
  }
}
